export default __webpack_public_path__ + "static/media/vote-on-werewolf.82d779e9.mp3";